const initialContentManagement = {
  termsAndConditions: {
    isBusy: false,
    result: undefined,
  },
};

export default initialContentManagement;
